import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const TextShimmer = ({ children, as: Component = "p", className, duration = 2, spread = 2 })=>{
    const dynamicSpread = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>children.length * spread, [
        children,
        spread
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Component, {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("relative inline-block bg-[length:250%_100%,auto] bg-clip-text", "text-transparent [--base-color:#71717a] [--base-gradient-color:#ffffff]", "[background-repeat:no-repeat,padding-box] [--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))]", "animate-shimmer", className),
        style: {
            "--spread": `${dynamicSpread}px`,
            backgroundImage: "var(--bg), linear-gradient(var(--base-color), var(--base-color))",
            animationDuration: `${duration}s`
        },
        children: children
    });
};
export { TextShimmer };
